import { makeStyles } from "@mui/styles";

export const useStyles = makeStyles(() => ({
  videoDiv: {
    position: "relative",
  },
}));
